import TooltipLegend from './TooltipLegend';

export { TooltipLegend };
